import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Button, Typography } from "@mui/material";
import * as XLSX from "xlsx";

function FileUploader({ onFileAccepted }) {
  const [error, setError] = useState("");
  const [borderColor, setBorderColor] = useState("#ccc");

  const validateExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          if (
            workbook &&
            workbook.SheetNames &&
            workbook.SheetNames.length > 0
          ) {
            resolve(true);
          } else {
            reject(false);
          }
        } catch {
          reject(false);
        }
      };

      reader.onerror = () => reject(false);
      reader.readAsArrayBuffer(file);
    });
  };

  const checkFileSignature = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = (e) => {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        const isZIP = header.startsWith("504b");
        const isXLS = header === "d0cf11e0";

        if (isZIP || isXLS) {
          resolve(true);
        } else {
          reject(false);
        }
      };
      reader.onerror = () => reject(false);
      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  };

  const onDropAccepted = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file.size === 0) {
        setError("Il file è vuoto.");
        setBorderColor("red");
        return;
      }

      const isCsvFile = (file.name || "").toLowerCase().endsWith(".csv");
      if (isCsvFile) {
        setError("");
        setBorderColor("#ccc");
        onFileAccepted(acceptedFiles);
        return;
      }

      try {
        const hasValidSignature = await checkFileSignature(file);
        if (!hasValidSignature) {
          setError("Il file non è un file Excel valido.");
          setBorderColor("red");
          return;
        }

        const isValid = await validateExcelFile(file);
        if (isValid) {
          setError("");
          setBorderColor("#ccc");
          onFileAccepted(acceptedFiles);
        } else {
          setError("Il file non è un file Excel valido.");
          setBorderColor("red");
        }
      } catch {
        setError("Il file non è un file Excel valido.");
        setBorderColor("red");
      }
    },
    [onFileAccepted],
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    onDropAccepted,
    onDropRejected: () => {
      setError("Il file deve essere in formato .xls, .xlsx o .csv");
      setBorderColor("red");
    },
    accept: ".xls,.xlsx,.csv",
    noClick: true,
    noKeyboard: true,
  });

  return (
    <Box>
      <Box
        {...getRootProps()}
        sx={{
          border: `2px dashed ${borderColor}`,
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
          borderRadius: "4px",
        }}
      >
        <input {...getInputProps()} />
        <Typography variant="h6">Trascina qui un file Excel o CSV</Typography>
        <Typography variant="body2" my={4}>
          Oppure
        </Typography>
        <Button variant="contained" onClick={open}>
          Seleziona un file
        </Button>
      </Box>
      {error && (
        <Typography variant="body2" color="error" sx={{ marginTop: "10px" }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}

export default FileUploader;
